import { render, staticRenderFns } from "./RecommendAuthorization.vue?vue&type=template&id=bec1c41c&scoped=true"
import script from "./RecommendAuthorization.vue?vue&type=script&lang=js"
export * from "./RecommendAuthorization.vue?vue&type=script&lang=js"
import style0 from "./RecommendAuthorization.vue?vue&type=style&index=0&id=bec1c41c&prod&lang=css"
import style1 from "./RecommendAuthorization.vue?vue&type=style&index=1&id=bec1c41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec1c41c",
  null
  
)

export default component.exports